<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Trámites Asignados</h4>
    <hr />

    <!-- Instrucciones -->
    <div class="alert alert-info py-2 px-3 mb-3" role="alert">
      <strong>Instrucciones:</strong>
      Doble clic en una fila para ver los detalles completos del registro.
      Seleccione una opción en las listas desplegables para ejecutar una acción.
    </div>

    <!-- Selector registros por página -->
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2" v-if="tramites.length > 0">
      <label class="form-label mb-0 small fw-bold">Mostrar</label>
      <select v-model.number="elementosPorPagina" class="form-select form-select-sm"
        style="width:75px" @change="aplicarPaginacion(1)">
        <option :value="10">10</option>
        <option :value="25">25</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
      <span class="small text-muted">registros</span>
    </div>

    <!-- Tabla -->
    <div class="table-responsive" v-if="tramites.length > 0">
      <table id="sampleTable" class="table table-hover table-bordered table-sm">
        <thead class="table-dark">
          <tr>
            <th class="th-sort" @click="ordenarPor('idTramite')">
              Número <span>{{ iconOrden('idTramite') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('razonSocial')">
              Prestador <span>{{ iconOrden('razonSocial') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('servicioNombre')">
              Servicio <span>{{ iconOrden('servicioNombre') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('cargaFechaDesde')">
              Fecha desde <span>{{ iconOrden('cargaFechaDesde') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('cargaFechaHasta')">
              Fecha hasta <span>{{ iconOrden('cargaFechaHasta') }}</span>
            </th>
            <th>Estado AM</th>
            <th>Estado GD</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="tramite in datosPaginados"
            :key="tramite.idTramite"
            @dblclick="handleRowClick($event, tramite.idTramite)"
            title="Doble clic para visualizar los detalles completos del registro"
          >
            <td>{{ tramite.idTramite }}</td>
            <td>{{ tramite.razonSocial }}</td>
            <td>{{ tramite.servicioNombre }}</td>
            <td>{{ getFormattedDate(tramite.cargaFechaDesde) }}</td>
            <td>{{ getFormattedDate(tramite.cargaFechaHasta) }}</td>
            <td>
              <span class="badge" :class="tramite.cargaFechaFinAud ? 'bg-success' : 'bg-warning text-dark'">
                {{ tramite.cargaFechaFinAud ? "PROCESADO" : "EN PROCESO" }}
              </span>
            </td>
            <td>
              <span class="badge" :class="tramite.cargaFechaFinDoc ? 'bg-success' : 'bg-warning text-dark'">
                {{ tramite.cargaFechaFinDoc ? "PROCESADO" : "EN PROCESO" }}
              </span>
            </td>
            <td>
              <select
                class="form-select form-select-sm"
                @change="handleAction($event, tramite.idTramite, tramite.idCarga)"
              >
                <option disabled selected>Seleccione...</option>
                <option value="resumen">Resumen</option>
                <option value="detalles">Detalles</option>
                <option value="recibir" v-if="tramite.estadoTramite === 'ENVIADO'">
                  Recibir
                </option>
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="8" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ tramitesOrdenados.length }} trámites
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Sin resultados -->
    <div v-if="tramites.length === 0" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros.
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="tramites.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ tramitesOrdenados.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
          </li>
          <li v-for="pagina in paginasVisibles" :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }">
            <a class="page-link" href="#"
              @click.prevent="pagina !== '...' && aplicarPaginacion(pagina)">
              {{ pagina }}
            </a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Botón recibir todos -->
    <div class="d-flex justify-content-center mt-3">
      <button
        @click="actualizarTodos"
        v-if="estadoBusqueda === 'ENVIADO'"
        class="btn btn-success"
      >
        Recibir Todos los Trámites
      </button>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">info</span>
            <h5 class="modal-title text-white" id="exampleModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
              data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Número</label></div>
                  <div class="col-9"><span>{{ datoTramite.idTramite }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Fecha reg.</label></div>
                  <div class="col-9"><span>{{ getFormattedDate(datoTramite.fechaReg) }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Prestador</label></div>
                  <div class="col-9"><span>{{ datoTramite.nombreComercial }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Servicio</label></div>
                  <div class="col-9"><span>{{ datoTramite.servicioNombre }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Fecha desde</label></div>
                  <div class="col-9"><span>{{ getFormattedDate(datoTramite.fechaDesde) }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Fecha hasta</label></div>
                  <div class="col-9"><span>{{ getFormattedDate(datoTramite.fechaHasta) }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Fecha desde (semana)</label></div>
                  <div class="col-9"><span>{{ getFormattedDate(datoTramite.cargaFechaDesde) }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Fecha hasta (semana)</label></div>
                  <div class="col-9"><span>{{ getFormattedDate(datoTramite.cargaFechaHasta) }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold"># registros</label></div>
                  <div class="col-9"><span>{{ datoTramite.numeroRegistros }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Descripción</label></div>
                  <div class="col-9"><span>{{ datoTramite.descripcion }}</span></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer },
  data() {
    return {
      tramites: [],
      datoTramite: {},
      nombreBusqueda: "",
      estadoBusqueda: "",
      titulo: "",
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      servicios: [],
      prestadores: [],
      prestadorBusqueda: null,
      mensaje: "",
      idUsuario: 0,
      idPerfil: 0,
      tipo: "",
      // ── Ordenamiento ──────────────────────────────────────
      campoOrden: 'idTramite',
      ascendente: false,
    };
  },
  computed: {
    // ── Trámites ordenados ─────────────────────────────────
    tramitesOrdenados() {
      const campo = this.campoOrden;
      return [...this.tramites].sort((a, b) => {
        let va = a[campo] ?? '';
        let vb = b[campo] ?? '';
        if (campo === 'idTramite') {
          const na = parseInt(va, 10);
          const nb = parseInt(vb, 10);
          if (!isNaN(na) && !isNaN(nb)) return this.ascendente ? na - nb : nb - na;
        }
        if (campo === 'cargaFechaDesde' || campo === 'cargaFechaHasta') {
          const da = new Date(va);
          const db = new Date(vb);
          if (!isNaN(da) && !isNaN(db)) return this.ascendente ? da - db : db - da;
        }
        const cmp = String(va).localeCompare(String(vb), 'es');
        return this.ascendente ? cmp : -cmp;
      });
    },
    // ── Páginas visibles con puntos suspensivos ────────────
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },
  mounted() {
    this.idUsuario = window.sessionStorage.getItem("idUsuario");
    this.idPerfil  = window.sessionStorage.getItem("idPerfil");
    if (this.idPerfil == 17 || this.idPerfil == 18 || this.idPerfil == 22) this.tipo = "aud";
    if (this.idPerfil == 19 || this.idPerfil == 20) this.tipo = "doc";
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    // ── Ordenamiento ───────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.aplicarPaginacion(1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },
    // ── Paginación ─────────────────────────────────────────
    totalPaginas() {
      return Math.max(1, Math.ceil(this.tramitesOrdenados.length / this.elementosPorPagina));
    },
    aplicarPaginacion(noPagina) {
      this.paginaActual   = noPagina;
      const ini           = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.tramitesOrdenados.slice(ini, ini + this.elementosPorPagina);
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.aplicarPaginacion(this.paginaActual + 1);
    },
    isActive(noPagina) {
      return noPagina === this.paginaActual ? 'active' : '';
    },
    // ── Carga de datos ─────────────────────────────────────
getDataPaginaTodos(noPagina) {
  api.get(`/vwtramitecargas/pendientes-por-tramite/${this.idUsuario}/${this.tipo}`)
    .then((response) => {
      this.tramites = response.data;
      this.aplicarPaginacion(noPagina);
    })
    .catch((error) => {
      console.error("Error al obtener trámites:", error);
      this.tramites = [];
      this.aplicarPaginacion(noPagina);
    });
},
    // ── Helpers ────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    handleRowClick(event, idTramite) {
      if (event.target.tagName === 'SELECT' || event.target.tagName === 'OPTION') return;
      this.abrirEditar(idTramite);
    },
    handleAction(event, idTramite, idCarga) {
      const action = event.target.value;
      if (action === 'resumen')   this.abrirModalEditar(idTramite, idCarga);
      if (action === 'novedades') this.abrirNovedades(idTramite, idCarga);
      if (action === 'detalles')  this.abrirEditar(idTramite);
      event.target.value = 'Seleccione...';
    },
    validarForm() {
      const fields = ["idPrestador", "idServicio", "fechaDesde", "fechaHasta", "descripcion"];
      return validarForm(this.datoTramite, fields, fields);
    },
    abrirModalEditar(idTramite, idCarga) {
      this.modalWindow = true;
      if (idTramite != null) {
        api.get(`vwtramitecargas/idtramite-idcarga/${idTramite}/${idCarga}`)
          .then((resp) => { this.datoTramite = resp.data[0] || null; });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Resumen trámite " + idTramite;
    },
    abrirNovedades(idTramite, idCarga) {
      if (idTramite != null) this.$router.push(`/cargaplanillanovedades/${idTramite}/${idCarga}`);
    },
    abrirEditar(idTramite) {
      if (idTramite != null) this.$router.push("/tramiteform/" + idTramite);
    },
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
</style>	